import { PureComponent } from 'react';
import { findIndex } from 'lodash-es';
import WithScroll from 'hocs/WithScroll';

const MENU_ITEMS = [
  'The Essentials',
  'Photos & Videos',
  'Social & Blogs',
  'Forms & Maps',
  'Online Store',
  'Marketing',
];

class FeaturesNavList extends PureComponent {
  isTabClicked = false;

  containerNode = React.createRef();

  state = {
    sticky: false,
    activeId: 0,
  };

  componentDidMount() {
    const { scroll } = this.props;

    scroll.addListener('scroll', this.handleScrollNav);
    scroll.addListener('scrollStop', this.handleScrollStop);
  }

  componentWillUnmount() {
    const { scroll } = this.props;

    scroll.removeListener('scroll', this.handleScrollNav);
    scroll.removeListener('scrollStop', this.handleScrollStop);
  }

  handleScrollStop = () => {
    this.isTabClicked = false;
  };

  handleScrollNav = scrollTop => {
    const { offsetTop } = this.containerNode.current;

    if (!this.isTabClicked) {
      const id = this.getSectionPosition(scrollTop);

      if (id !== this.state.activeId && id >= 0) {
        this.setState({ activeId: id });
      }
    }

    if (
      scrollTop >= offsetTop &&
      !this.state.sticky &&
      document.body.clientWidth > 1024
    ) {
      this.setState({ sticky: true });
      return;
    }

    if (scrollTop <= offsetTop && this.state.sticky) {
      this.setState({ sticky: false });
    }
  };

  getSectionPosition = scrollTop =>
    findIndex(this.props.nodesList, item => item.offsetTop > scrollTop - 50);

  handleNavItemClick = e => {
    this.isTabClicked = true;
    const { navId } = e.target.dataset;

    if (this.state.activeId !== +navId) {
      this.setState({ activeId: +navId });
    }

    const { offsetTop } = this.props.nodesList[+navId];
    this.props.scroll.triggerScrolling(offsetTop - 50, true);
  };

  render() {
    const { sticky, activeId } = this.state;
    return (
      <section
        className={cx('section', 'section_sticky', '_mb-50', '_mb-tablet-10', {
          'sticky-nav': sticky,
        })}
        ref={this.containerNode}
      >
        <ul className="tab-menu">
          {MENU_ITEMS.map((text, key) => (
            <li
              className={cx('tab-menu__item', {
                'tab-menu__item_active': activeId === key,
              })}
              key={key}
              onClick={this.handleNavItemClick}
            >
              <label className="tab-menu__item-text" data-nav-id={key}>
                {text}
              </label>
            </li>
          ))}
        </ul>
      </section>
    );
  }
}

export default WithScroll(FeaturesNavList);
